import { Controller } from "@hotwired/stimulus"

// Off-canvas sidebar drawer for screens below `lg`. On `lg+` the sidebar is
// static (always visible) via CSS, and this controller is effectively inert.
//
//   <div data-controller="sidebar">
//     <aside data-sidebar-target="panel" class="... -translate-x-full lg:translate-x-0">
//     <div  data-sidebar-target="overlay" data-action="click->sidebar#close" class="hidden">
//     <button data-action="sidebar#open">   (in the topbar, lg:hidden)
//
// Navigation still works without JS — the drawer simply doesn't animate.
export default class extends Controller {
  static targets = ["panel", "overlay"]

  connect() {
    this._onKey = this._onKey.bind(this)
    this._onTurbo = this.close.bind(this)
    document.addEventListener("keydown", this._onKey)
    // Close when navigating (Turbo) so the drawer never lingers over a new page.
    document.addEventListener("turbo:load", this._onTurbo)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey)
    document.removeEventListener("turbo:load", this._onTurbo)
    this._unlockScroll()
  }

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    this.overlayTarget.classList.remove("hidden")
    this.panelTarget.setAttribute("aria-hidden", "false")
    this._lockScroll()
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    this.overlayTarget.classList.add("hidden")
    this.panelTarget.setAttribute("aria-hidden", "true")
    this._unlockScroll()
  }

  _onKey(event) {
    if (event.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) this.close()
  }

  _lockScroll() {
    document.body.classList.add("overflow-hidden", "lg:overflow-auto")
  }

  _unlockScroll() {
    document.body.classList.remove("overflow-hidden", "lg:overflow-auto")
  }
}
